import React from "react"
import Link from "./link";
import { domain, extractredYear } from '../utils';
import { graphql } from 'gatsby';
import MouseHover from "./mouseHover";
import Tags from "./tags";
import classNames from "classnames";

const CardArticle = ({ article, path ,showMobileImage, showLandingPreview, sectionBackgroundColor, shouldNotLazyLoad, isCasesPage, media, isCaseDetailPage, imageBorderRadiusForServices, hashtagsBackgroundColor}) => {
  if (isCaseDetailPage) {
    return (
      <article
        className="card-article col"
        role="listitem"
      >
        <img 
          style={{borderRadius: imageBorderRadiusForServices}}       
          src={`${media?.url}`}  
          className="image--fluid" 
          {...(!shouldNotLazyLoad && { loading: "lazy" })} 
        />
      </article>
    )
  }
  if (!article) { return <article></article>; }

  const isNew = (createdAt) => {
    const postDate = new Date(createdAt); // Convert to Date object
    const currentDate = new Date(); // Current date
    const daysDifference = Math.floor((currentDate - postDate) / (1000 * 60 * 60 * 24)); // Difference in days
    return daysDifference <= 30; // Returns true if within 30 days
  };

  const { date } = article;
  const currentYear = extractredYear(date);
  const caseLandingPagesPreviewImage = path === 'case-studies' && showLandingPreview;

  return (
    <article
      className="card-article col-sm-4"
      role="listitem"
    >
      <Link
        className="card-article__wrap"
        to={`/${article.language}/${path}/${article.slug}`}
        title={article.title}
      >
       <MouseHover 
         classId={`card-article__image nocursor ${article.tags && article.tags.length > 0 ? "mb-0" : ""}`} 
         borderRadius={imageBorderRadiusForServices}
       >
        {isNew(article.date) && (<div className="card-article__image--new"><span>New</span></div>)}
        {path !== "case-studies" && (
          <div className="card-article__image--year" style={{backgroundColor: sectionBackgroundColor}}>
            <span>{currentYear}</span></div>
        )}

        {caseLandingPagesPreviewImage && (
          <img 
            style={{borderRadius: imageBorderRadiusForServices}}       
            src={`${article.caseLandingPagesImage && article.caseLandingPagesImage.url}`} 
            alt={article.caseLandingPagesHeading} 
            className="image--fluid" {...(!shouldNotLazyLoad && { loading: "lazy" })} 
          />    
        )}

        {!caseLandingPagesPreviewImage && (
          showMobileImage ? (
            <img 
              style={{borderRadius: imageBorderRadiusForServices}}       
              src={`${article.headerImageMobile && article.headerImageMobile.url}`} 
              alt={article.title} 
              className="image--fluid" {...(!shouldNotLazyLoad && { loading: "lazy" })} 
            />
          ) : (
            <img
              style={{borderRadius: imageBorderRadiusForServices}}       
              className = "image--fluid"  
              src = {`${isCasesPage  ? (article.previewImage && article.previewImage.url ? article.previewImage && article.previewImage.url : article.headerImage && article.headerImage.url  ) : article.headerImage && article.headerImage.url }`}
              alt="placeholder"
              {...(!shouldNotLazyLoad && { loading: 'lazy' })}   
            />
        ))}
       </MouseHover>
        <Tags 
          tags={article.tags.filter((tag) => tag?.active)} 
          hashtagsBackgroundColor={hashtagsBackgroundColor} 
          borderRadius={imageBorderRadiusForServices}
        />
        <h2 className={classNames("card-article__header", {"mt-0": article.tags && article.tags.length})}>          
          {article.title}
        </h2>
      </Link>
    </article>
  )
}

export const query = graphql`
  fragment CardArticleBlog on STRAPI_Blog {
    language
    slug
    inactive
    headerImage {
      url
    }
    headerImageMobile {
      url
    }
    title
    intro
    tags {
      tag
      active
    }
    date
  }
  fragment CardArticleCaseStudy on STRAPI_CaseStudy {
    clientLogo {
      logo {
        url 
      }
    }
    caseLandingPagesHeading
    caseLandingPagesImage {
      url
    }
    language
    slug
    inactive
    showCaseOnCasesOverview
    headerImage {
      url
    }
    decriptionDisplayText
    showDescriptionTextLink
    headerImageMobile{
      url
    }
    showCtaButton
    previewImage {
      url
    }
    title
    description
    tags {
      tag
      active
    }
    date
  }
`

export default CardArticle